import React from 'react';

const OnboardingSubSteps = ({ details, user, counts, onShowMe, to }) => {
    return (
        <div className="onboarding-substeps">
            {details.map((detail) => {
                const isDone = detail.done(user, counts);
                return (
                    <div key={detail.id} className={`onboarding-substep ${isDone ? 'done' : ''}`}>
                        <span className="onboarding-substep-icon">
                            {isDone ? '✓' : '○'}
                        </span>
                        <span className="onboarding-substep-label">{detail.label}</span>
                        {!isDone && detail.tour && (
                            <button
                                className="onboarding-substep-show"
                                onClick={() => onShowMe(to || '/userProfile', detail.tour)}
                            >
                                Göster
                            </button>
                        )}
                        {isDone && <span className="onboarding-substep-badge">Tamamlandı</span>}
                    </div>
                );
            })}
        </div>
    );
};

export default OnboardingSubSteps;
